import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage, IntlShape, defineMessages} from 'react-intl';
import Link from 'react-router/lib/Link';

import urlMapping from '../app/URLMapping';
import Logo from './Logo.react';

import {sendToExtension, getExtensionURL} from './ExtensionCommunicate';
import {getSupportedLocales, setLocale, getLocale} from './../locales';
import {detect} from 'detect-browser';

import './Header.scss';
import * as BrowserPermission from '../BrowserPermission';
import * as Permission from '../../common/util/Permission';
import { Organisation } from '../../common/types/types';

const messages = defineMessages({
    regularUser: {
        id: 'header.viewMode.regularUser',
        defaultMessage: 'Regular user',
    },
    partner1: {
        id: 'header.viewMode.partner1',
        defaultMessage: 'Partner 1',
    },
    partner2: {
        id: 'header.viewMode.partner2',
        defaultMessage: 'Partner 2',
    },
    developer: {
        id: 'header.viewMode.developer',
        defaultMessage: 'Developer',
    },
});

class Header extends React.PureComponent {
    static propTypes = {
        developerMode: PropTypes.bool,
        getViewMode: PropTypes.func,
        installExtension: PropTypes.func,
        missingExtension: PropTypes.bool,
        orgChooser: PropTypes.node,
        organisation: PropTypes.object,
        toggleLeftMenu: PropTypes.func,
        toggleViewMode: PropTypes.func,
        userProfile: PropTypes.node,
    };

    constructor() {
        super();

        const browser = detect();
        this.browserName = browser.name;
        document.body.parentElement.classList.add(this.browserName);
    }

    componentDidMount() {
        import(/* webpackChunkName: "bootstrap" */ 'bootstrap');
    }

    render() {
        return (
            <div className="Header">
                <button className="navbar-toggle" onClick={() => this.props.toggleLeftMenu()} type="button" >
                    <span className="icon-bar"/>
                    <span className="icon-bar"/>
                    <span className="icon-bar"/>
                </button>
                <Link className="navbar-brand dativery-logo" to={urlMapping.getUrl("organisations", "view", this.props.organisation)}>
                    <Logo color/>
                </Link>
                <div className="optionalFlex" />
                <div className="organisation-chooser-wrap">
                    <ul className="nav">
                        {this.props.orgChooser}
                    </ul>
                </div>
                <div className="optionalFlex2" />
                {/* <ul className="nav navbar-nav navbar-right" style={{marginRight: '10px'}}>
                    {this.props.missingExtension ? <li><a href={getExtensionURL()} id="extension-missing" onClick={(e) => {
                        this.props.installExtension();
                        e.preventDefault();
                    }} style={{backgroundColor: '#E76049'}}><span className={"fa fa-fw fa-" + this.browserName}/> <span className="visible-xs-inline"><FormattedMessage defaultMessage="Missing browser extension" id="main.missingExtension" /></span></a></li> : null}
                </ul> */}
                {/* {BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) ? <div className="developerMode">
                    <ul className="nav navbar-nav navbar-right" style={{marginRight: '10px'}}>
                    <li><div id="extension-missing" onClick={(e) => {
                    this.props.toggleDeveloperMode();
                }} style={{color: this.props.developerMode ? '#ffffff' : '#000000', padding: '15px', backgroundColor: this.props.developerMode ? '' : '#E76049', 'cursor': 'pointer'}}><span className={"fa fa-fw fa-bug"} /> </div></li></ul></div> : null} */}

                {BrowserPermission.canHaveDeveloperMode() ?
                <div className='developerMode'>
                    <ul className="nav navbar-nav navbar-right" style={{marginRight: "10px", marginLeft: "10px", cursor: 'pointer'}}>
                        <li className="dropdown">
                            <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                            <span className='fa fa-fw fa-bug'></span></a>
                            <ul className="dropdown-menu" role="menu">
                                <li
                                    onClick={() => {
                                        this.props.toggleViewMode(null);
                                    }}
                                    //use getViewMode() to get the current view mode and if is null, set the style to bold
                                    style={{backgroundColor: !this.props.getViewMode() ? '#cd9b33' : null}}>
                                        <a href=''>🧍{this.props.intl.formatMessage(messages.regularUser)}</a>
                                </li>
                                <li
                                    onClick={() => {
                                        this.props.toggleViewMode(BrowserPermission.VIEW_MODE_PARTNER1);
                                    }}
                                    style={{backgroundColor: this.props.getViewMode() === BrowserPermission.VIEW_MODE_PARTNER1 ? "#cd9b33" : null}}>
                                        <a href=''>👨‍💼{this.props.intl.formatMessage(messages.partner1)}</a>
                                </li>
                                <li
                                    onClick={() => {
                                        this.props.toggleViewMode(BrowserPermission.VIEW_MODE_PARTNER2);
                                    }}
                                    style={{backgroundColor: this.props.getViewMode() === BrowserPermission.VIEW_MODE_PARTNER2 ? "#cd9b33" : null}}>
                                        <a href=''>🧑‍💼{this.props.intl.formatMessage(messages.partner2)}</a>
                                </li>
                                <li
                                    onClick={() => {
                                        this.props.toggleViewMode(BrowserPermission.VIEW_MODE_DEVELOPER);
                                    }}
                                    style={{backgroundColor: this.props.getViewMode() === BrowserPermission.VIEW_MODE_DEVELOPER ? "#cd9b33" : null}}>
                                        <a href=''>👨‍💻{this.props.intl.formatMessage(messages.developer)}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div> : null}

                <div className="langChooser">
                    <li className="dropdown">
                        <a className="dropdown-toggle" data-toggle="dropdown" href="#"><img alt={getLocale()} height={16} src={"/cdn/assets/flags/" + getLocale() + ".svg"}/></a>
                        <ul className="dropdown-menu" role="menu">
                            {
                                Object.keys(getSupportedLocales()).filter((locale) => getLocale() !== locale).map((locale) => {
                                    return (<li key={locale}><a href="" onClick={() => {
                                        sendToExtension({
                                            message: 'dativery-set-locale',
                                            data: {
                                                locale: locale
                                            }
                                        });
                                        setLocale(locale);
                                    }}><img alt={locale} height={18} src={"/cdn/assets/flags/" + locale + ".svg"} style={{paddingBottom: '2px'}}/></a></li>);
                                })
                            }
                        </ul>
                    </li>
                </div>
                <div className="userProfile">
                    {this.props.userProfile}
                </div>
            </div>
        );
    }
}

export default injectIntl(Header);
